import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: React.ReactNode;
  cancelLabel?: React.ReactNode;
  destructive?: boolean;
  /** Disable confirm (e.g. while a mutation is in flight). */
  confirmDisabled?: boolean;
  /**
   * When false, the dialog stays open after confirm so the caller can close
   * it after an async action finishes. Defaults to true.
   */
  closeOnConfirm?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
};

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive,
  confirmDisabled = false,
  closeOnConfirm = true,
  onConfirm,
  onCancel,
}: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <DialogFooter>
        <Button
          variant="outline"
          disabled={confirmDisabled}
          onClick={() => {
            onCancel?.();
            onOpenChange(false);
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          variant={destructive ? 'destructive' : 'default'}
          disabled={confirmDisabled}
          onClick={() => {
            if (confirmDisabled) return;
            onConfirm();
            if (closeOnConfirm) onOpenChange(false);
          }}
        >
          {confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
